/* eslint-disable */
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui components
import withStyles from "material-ui/styles/withStyles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import ImageGridOne from "../UI/ImageGridOne";
import ImageGridTwo from "../UI/ImageGridTwo";
// core components
import downloadStyle from "assets/jss/material-kit-react/views/componentsSections/downloadStyle.jsx";

import Divider from 'material-ui/Divider';
import LogoLarge from 'assets/img/Logos/LogoLarge.svg';

class SectionContent extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer className={classes.textLeft} justify="center">
            <GridItem xs={12} sm={12} md={8}>
            <h2><strong>Looking for Entrepreneurs for European company projects</strong></h2>
            <h3>
              Willing to dare to live your dream and take web development to
              the next level when surrounded by stunning beaches and high-end venues
              in a tropical country?
              </h3>
              <h3>
              Instead of wondering when your next vacation is, you should 
              set up a life you don’t need to escape from.
              </h3>
              <br/>
              <h3><strong>What is Project SouthEast Asia (SEA)?</strong></h3>
              <h4>
                It is all about creating an international headquarters, where freelancers
                from all over the world can unite and be inspired. By their ideas, the atmosphere,
                and by each other.
              </h4>
              <h4>
                It is your chance to work from where you're most inspired.
                It's up to you to decide what you want to do and when.
              </h4>
            </GridItem>
            </GridContainer>
            <br />
              <Divider />
            <br />
            <GridContainer className={classes.textLeft} justify="center">
            <GridItem xs={12} sm={12} md={8}>
              <h2><strong>Education</strong></h2>
              <h3><strong>
                Learning from each other is key! Keen to teach and learn from you.
              </strong></h3>
              <h4>Although I love coding, designing and thinking of better UI's and UX's,
              I enjoy the process digging into the problems by trying to explain 
              them to myself, and bring the solutions visually in the real world. 
              </h4>
              <h4>After years of teaching the English language to Asian students,
              I learnt the necessary skills to transfer knowledge to others. I still 
              love it and would like to help other entrepeneurs in the fields of Web development,
              styling, Photography, Photoshop, and logo design in Illustrator. </h4>
            </GridItem>
            </GridContainer>
            <br />
              <GridContainer justify="center">
                   <ImageGridOne />
              </GridContainer>
            <br />
            <br />
            <GridContainer className={classes.textLeft} justify="center">
              <GridItem xs={12} sm={12} md={8}>
                <h2><strong>Creating awesome projects together</strong></h2>
                <h3><strong>
                Your opportunities to work with me:
                </strong></h3>
                <ul>
                  <li><strong>Are you a strong Web/Mobile Developer or working on a framework relevant to JavaScript? </strong>Together, 
                  we could find a way to bundle our expertises and implement them into the projects.</li>
                  <br />
                  <li><strong>Are you a UI/UX Designer? </strong>I truly love great designs and always watch and learn from others to keep it clean, logical and simple.
                  </li>
                  <br />
                  <li><strong>Are you text writer, Sales & Marketing Expert or E-Commerce Developer? </strong>Loads
                  of opportunities in Indonesia, Malaysia, Thailand and Vietnam. Let's join and find out.
                  </li>
                  <br />
                  <li>
                  <strong>Is your company looking for exposure in SouthEast Asia to attract software engineers and web developers? </strong>Let's
                  work together and find them. It would be much better if you're based in Asia. I can help you out while based in Bali.
                  </li>
                 </ul> 
              </GridItem>
              </GridContainer>
              <br/>
              <GridContainer justify="center">
                <ImageGridTwo />
              </GridContainer>
              <br/>
              <br/>
              <GridContainer className={classes.textCenter} justify="center">
            <GridItem xs={12} sm={6}>
                  <img
                    src={LogoLarge}
                    alt="Logo"
                    />
              </GridItem>
          </GridContainer>
          </div>
        </div>
    );
  }
}

export default withStyles(downloadStyle)(SectionContent);



// WEBPACK FOOTER //
// ./src/views/ProjectPage/Sections/SectionContent.jsx